/**
 * Focuses the element with the given identifier.
 * @param identifier - The identifier of the element to focus. Either id of the element or a ref to the element.
 */
export const focus = (identifier: string | React.RefObject<HTMLElement>) => {
	if (typeof identifier === 'string') {
		window.setTimeout(
			(id: string) => {
				const element = document.getElementById(id);

				if (element && document.body.contains(element)) {
					element.focus();
				}
			},
			0,
			identifier,
		);

		return;
	}

	window.setTimeout(
		(ref: React.RefObject<HTMLElement>) => {
			if (ref.current) {
				ref.current.focus();
			}
		},
		0,
		identifier,
	);
};
